import { archiveItem } from "@/components/page/Archive";
import { IHttpRequest } from  "@/interfaces/IHttp";
import { container, TYPES } from  "@/inversifyconfig/container.config";

const http = container.get<IHttpRequest>(TYPES.IHttpRequest); 

export async function getViewerCount(listId: string): Promise<any> {
    const res = await http.get(`content/${listId}/listInfoModal/viewCount`);
    
    if(res.data) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get viewCount`))
}

export async function resetViewCount(listId: string) {  
    const res = await http.delete(`content/${listId}/listInfoModal/responses`, {});

    if(res.status === 204) {
        return Promise.resolve(true)
    }
    return Promise.reject(new Error(`Error with resetting View Count.`))
}